export default function BrandLogo({ size = 36 }: { size?: number }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
        >
            <path
                d="M32 6.5L52.5 18.5V45.5L32 57.5L11.5 45.5V18.5L32 6.5Z"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinejoin="round"
            />
            <path
                d="M22 36L32 24L42 36"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="22" cy="36" r="3.5" fill="currentColor" />
            <circle cx="32" cy="24" r="3.5" fill="currentColor" />
            <circle cx="42" cy="36" r="3.5" fill="currentColor" />
            <path
                d="M22 36L32 44L42 36"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                opacity="0.85"
            />
            <circle cx="32" cy="44" r="3.5" fill="currentColor" opacity="0.85" />
        </svg>
    );
}